/**
 * Encaptulates functionality to store and retrieve FRP data from the data store
 */
import { VersionedObjectPersistence } from "src/common/managers/ESVersionedPersistance";
import { FRPProject, FRPProjectPersistenceInterface} from "./FRPState";

   export class FRPProjectPersistence extends VersionedObjectPersistence<FRPProject> implements FRPProjectPersistenceInterface {

      public static indexMappings =
      {
      "properties": {
         "geopoint": {
            "type": "geo_point"
         },
         "geoshape": {
            "type": "geo_shape"
         },
         "point": {
            "type": "geo_point"
         },
         "geometry": {
            "type": "geo_shape"
         },
         "viamapUserId": {
            "type": "keyword"
         },
         "lastChangedTimestamp": {
            "type": "date"
         },
         "expectedStartDate": {
            "type": "date"
         },
         "expectedEndDate": {
            "type": "date"
         }
         // Other fields are dynamic and assigned a type automatically by ES
      }
      }
      private static idGetter = (object) => { return object.id; }
      
      constructor(objectsESIndexName:string, userId:string) {

         super(objectsESIndexName, userId, {}, FRPProjectPersistence.idGetter)

      }

   }

